    <template>
    <div class="calendario text-xs-center pt-4">
        <h1 class="my-4">Impostazioni</h1>
         <!-- OGGI  -->
        <v-layout row wrap >
            <v-flex xs12 md6 offset-md3>
                <v-text-field :disabled="true" :value="picker" label="Oggi"></v-text-field>
            </v-flex>     
        </v-layout>

        <!-- GIORNI LAVORATIVI SETTIMANALI  -->
        <h2 class="my-4">Seleziona giorni di apertura/chiusura settimanale</h2>
        <v-flex class="mb-5" row wrap>
            <v-layout v-for="(giorno, index) in settimana.slice(0,7)" :key="giorno.index" d-inline-block class="mx-5">
                <v-switch color="red darken-2" v-model="giorno.aperto" @change="chiusuraSettimanaleSalvata(giorno.id, index)"> </v-switch>
                <h4>{{ giorno.nomeGiorno }}</h4> <hr>
                <span v-if="giorno.aperto">Aperto </span>
                <span v-else>Chiuso </span>
            </v-layout>     
        </v-flex>
        
        <!-- FASCIE ORARIE GIORNALIERE  -->
        <h2 class="my-4">Imposta fascia oraria per singolo giorno lavorativo</h2>

        <v-container v-for="giorno in orario.slice(0,7)" :key="giorno.index" class="my-0 py-0" row justify-center>

            <v-layout v-if="aggiornaGiornoOrario(giorno.indice)" wrap justify-center>
                <div>
                <v-flex xs12 sm1 class="mr-4">
                    <v-checkbox
                    label="Continuato" 
                    v-model="giorno.continuato"
                    ></v-checkbox>
                </v-flex> 
                </div>
                <v-flex xs12 sm1 class="title my-3 cyan--text text--darken-2 ">
                    <span>{{ giorno.nomeGiorno }} </span>
                </v-flex>
                <v-flex xs6 sm1 class="mx-1">
                    <v-text-field
                    label="Inizio"
                    v-model="giorno.inizio1" 
                    type="time"
                    width="20px"
                    ></v-text-field>
                </v-flex>
                <v-flex xs6 sm1 class="mx-1">
                    <v-text-field
                    label="Fine" 
                    v-model="giorno.fine1" 
                    type="time"
                    ></v-text-field>
                </v-flex>      
                <v-flex v-show="!giorno.continuato" xs12 sm1 class="pink--text text--darken-2 mx-1 my-3">
                    <span>Pausa</span>
                </v-flex>
                <v-flex v-show="!giorno.continuato" xs6 sm1 class="mx-1">
                    <v-text-field
                    label="Inizio" 
                    v-model="giorno.inizio2" 
                    type="time"
                    width="20px"
                    ></v-text-field>
                </v-flex>
                <v-flex v-show="!giorno.continuato" xs6 sm1 class="mx-1">
                    <v-text-field
                    label="Fine" 
                    v-model="giorno.fine2" 
                    type="time"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm1>
                <v-btn @click="salvaOrarioGiorno(giorno.id, giorno.indice)" small class="lash white--text my-3">SALVA</v-btn>
                </v-flex>

                <v-snackbar v-model="snackbarFascia" :timeout="4000" color="success">
                    <span>Fascia oraria salvata.</span>
                    <v-btn flat color="white" @click="snackbarFascia=false">Close</v-btn>
                </v-snackbar>                
                
            </v-layout>
          
        </v-container>

        <!-- DISPONIBILITA' LASHMAKER  -->
        <h2 class="mt-5">Disponibilità Lashmaker</h2>

        <v-container>
            <v-layout wrap justify-center>
                <v-flex xs10 sm3 class="mx-1">
                    <v-select
                    :items="nomeLashmaker" 
                    v-model="nomeCognome" 
                    label="Seleziona una Lashmaker" 
                    @change="calendarioLashmaker(nomeCognome)"
                    ></v-select>
                </v-flex>
            </v-layout>    
        </v-container>

        <!-- UNA VOLTA SELEZIONATA LA LASHMAKER COMPARIRA' IL CALENDARIO DELLE SUE DISPONIBILITA' -->
      
        <v-container v-for="giorno in orarioLashmaker.slice(0,7)" :key="giorno.index" class="my-0 py-0" row justify-center>

            <v-layout v-if="aggiornaGiornoOrario(giorno.indice)" wrap justify-center> 
                <div v-show="orario[giorno.indice].continuato">
                <v-flex  xs12 sm1 class="mr-4">
                    <v-checkbox
                    label="Continuato"
                    v-model="giorno.continuato"
                    ></v-checkbox>
                </v-flex> 
                </div>               
                
                <v-flex xs12 sm1 class="title my-3 cyan--text text--darken-2 ">
                    <span>{{ giorno.nomeGiorno }} </span>
                </v-flex>
                <v-flex xs6 sm1 class="mx-1">
                    <v-text-field
                    label="Inizio"
                    v-model="giorno.inizio1" 
                    :rules="[ inputRulesInizio1(giorno.indice) ]" 
                    type="time"
                    width="20px"
                    ></v-text-field>
                </v-flex>
                <v-flex xs6 sm1 class="mx-1">
                    <v-text-field
                    label="Fine" 
                    v-model="giorno.fine1" 
                    :rules="[ inputRulesFine1(giorno.indice) ]" 
                    type="time"
                    ></v-text-field>
                </v-flex>      
                <v-flex v-show="!giorno.continuato" xs12 sm1 class="pink--text text--darken-2 mx-1 my-3">
                    <span>Pausa</span>
                </v-flex>
                <v-flex v-show="!giorno.continuato" xs6 sm1 class="mx-1">
                    <v-text-field
                    label="Inizio" 
                    v-model="giorno.inizio2" 
                    :rules="orario[giorno.indice].continuato ? [ inputRulesInizio1(giorno.indice) ] : [ inputRulesInizio2(giorno.indice) ]" 
                    
                    type="time"
                    width="20px"
                    ></v-text-field>
                </v-flex>
                <v-flex v-show="!giorno.continuato" xs6 sm1 class="mx-1">
                    <v-text-field
                    label="Fine" 
                    v-model="giorno.fine2" 
                    :rules="orario[giorno.indice].continuato ? [ inputRulesFine1(giorno.indice) ] : [ inputRulesFine2(giorno.indice) ]" 
                    type="time"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm1>
                <v-btn @click="salvaOrarioLashmaker(giorno.id, giorno.indice)" small :disabled="abilitaSalva(giorno.indice)" class="lash white--text my-3">SALVA</v-btn>
                </v-flex>     

                <v-snackbar v-model="snackbarLashmaker" :timeout="4000" color="success">
                    <span>Orario Lashmaker salvato.</span>
                    <v-btn flat color="white" @click="snackbarLashmaker=false">Close</v-btn>
                </v-snackbar>    

            </v-layout>
        
        </v-container>   
        <!-- INTERVALLO FRA UN TRATTAMENTO E L'ALTRO  -->
        <h2 class="mt-5">Seleziona l'intervallo fra un trattamento e l'altro</h2>       

        <v-container>
            <v-layout wrap justify-center>
                <v-flex xs10 sm3 class="mx-1">
                    <v-select
                    :items="initIntervalli" 
                    v-model="intervallo" 
                    label="Seleziona intervallo" 
                    ></v-select>
                </v-flex>
                <v-flex xs12 class="mx-4">
                  <v-btn @click="salvaIntervallo()" class="lash white--text">SALVA INTERVALLO</v-btn>
                </v-flex>      

                <v-snackbar v-model="snackbarIntervallo" :timeout="4000" color="success">
                    <span>Intervallo salvato.</span>
                    <v-btn flat color="white" @click="snackbarIntervallo=false">Close</v-btn>
                </v-snackbar>                           

            </v-layout>    
        </v-container>        

        <!-- PERIODO FERIE "DA - A"  -->
        <h2 class="mt-5">Seleziona il periodo di chiusura per ferie</h2>

        <v-container grid-list-md>
            <v-layout v-for="(giornoFerie, index) in ferie.slice(0,1)" :key="giornoFerie.index" wrap justify-center>
                <v-flex xs12 lg3 class="mx-4">
                    <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="200px"
                    min-width="290px"
                    >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                        v-model="giornoFerie.dateIn"
                        label="Inizio Ferie"
                        prepend-icon="event"            
                        v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="giornoFerie.dateIn" no-title @input="menu1 = false" locale="it"></v-date-picker>
                    </v-menu>
                </v-flex>

                <v-flex xs12 lg3 class="mx-4">
                    <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="200px"
                    min-width="290px"
                    >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                        v-model="giornoFerie.dateOut" 
                        label="Fine Ferie"
                        prepend-icon="event"            
                        v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="giornoFerie.dateOut" no-title @input="menu2 = false" :min="giornoFerie.dateIn" locale="it"></v-date-picker>
                    </v-menu>
                </v-flex>

                <v-flex xs12 class="mx-4">
                  <v-btn @click="salvaFerie(giornoFerie.id, index)" class="lash white--text">SALVA FERIE</v-btn>
                </v-flex>

                <v-snackbar v-model="snackbar" :timeout="4000" color="success">
                    <span>Ferie salvate.</span>
                    <v-btn flat color="white" @click="snackbar=false">Close</v-btn>
                </v-snackbar>

            </v-layout>
            <v-layout wrap justify-center>
                
            </v-layout>
        </v-container>
        
         <!-- IL TUO CALENDARIO  -->
        <h2 class="mt-5">Il tuo calendario</h2>
        <v-layout justify-center>
            <v-date-picker
            v-model="picker"  
            :allowed-dates="allowedDates"
            class="my-4"
            :min="minDate" 
            locale="it"     
            ></v-date-picker>
        </v-layout>
    </div>
</template>

<script>
import format from "date-fns/format"
import fb from "@/fb"

export default {
    data() {
        return {
            giorno_selezionato: null,
            openDate: new Date().toISOString().substr(0, 10),
            picker: new Date().toISOString().substr(0, 10),
            loading: false,
            snackbar: false,
            snackbarFascia: false,
            snackbarLashmaker: false,
            snackbarIntervallo: false,
            nomeGiorno: null,
            aperto: true,
            settimana: [],
            // struttura di comodo per la creazione della collection db 
            // all'esecuzione della prima istanza */
            sett: [
                {nomeGiorno: "Lun", aperto: true, indice: 0},
                {nomeGiorno: "Mar", aperto: true, indice: 1},
                {nomeGiorno: "Mer", aperto: true, indice: 2},
                {nomeGiorno: "Gio", aperto: true, indice: 3},
                {nomeGiorno: "Ven", aperto: true, indice: 4},
                {nomeGiorno: "Sab", aperto: true, indice: 5},
                {nomeGiorno: "Dom", aperto: true, indice: 6}
            ],
            // struttura giorni chiusura ferie
            ferie: [],          
            initFerie: [
                {dateIn : new Date().toISOString().substr(0, 10),
                 dateOut: new Date().toISOString().substr(0, 10)
                }
            ],
            menu1: false,
            menu2: false,
            // struttura fascia oraria per singolo giorno
            orario: [],
            initOrario: [
                {nomeGiorno: "Lun", inizio1: "00:00", fine1: "00:00", inizio2: "00:00", fine2: "00:00", indice: 0, continuato: false},
                {nomeGiorno: "Mar", inizio1: "00:00", fine1: "00:00", inizio2: "00:00", fine2: "00:00", indice: 1, continuato: false},
                {nomeGiorno: "Mer", inizio1: "00:00", fine1: "00:00", inizio2: "00:00", fine2: "00:00", indice: 2, continuato: false},
                {nomeGiorno: "Gio", inizio1: "00:00", fine1: "00:00", inizio2: "00:00", fine2: "00:00", indice: 3, continuato: false},
                {nomeGiorno: "Ven", inizio1: "00:00", fine1: "00:00", inizio2: "00:00", fine2: "00:00", indice: 4, continuato: false},
                {nomeGiorno: "Sab", inizio1: "00:00", fine1: "00:00", inizio2: "00:00", fine2: "00:00", indice: 5, continuato: false},
                {nomeGiorno: "Dom", inizio1: "00:00", fine1: "00:00", inizio2: "00:00", fine2: "00:00", indice: 6, continuato: false},
            ],
            // struttura disponibilità Lashmaker
            orarioLashmaker: [],
            lashmaker: [],
            nomeCognome: "",
            // struttura intervalli
            initIntervalli: ["00:05", "00:10", "00:15", "00:20", "00:25", "00:30"],
            intervallo: "00:00"
        }
    },
    computed: {      
        minDate() {
          return this.openDate ? format(this.openDate, "YYYY-MM-DD") : ""
        },        
        formattedDateIn() {
            return this.ferie.dateIn ? format(this.ferie.dateIn, "DD-MM-YYYY") : ""
        },
        formattedDateOut() {
          return this.ferie.dateOut ? format(this.ferie.dateOut, "DD-MM-YYYY") : ""
        },
        nomeLashmaker() {
            return this.lashmaker.map(lashmaker => {
                return lashmaker.nome + " " + lashmaker.cognome
            })
        }
    },
    methods: {    
        aggiornaGiornoOrario(indice) {
            if ( this.settimana[indice].nomeGiorno == this.orario[indice].nomeGiorno &&
                 this.settimana[indice].aperto == true ) {
                 return true
            } else { 
                 return false
            }
        },
        allowedDates(val) {
            try {
                if (val >= this.ferie[0].dateIn && val <= this.ferie[0].dateOut) {
                    return false
                } else {
                    let val1 = format(val,"ddd",{ locale: require('date-fns/locale/it') })
                    let val2 = val1.charAt(0).toUpperCase() + val1.slice(1)
                    return this.settimana.find(res => res.nomeGiorno == val2).aperto
                }
            }
            // eslint-disable-next-line
            catch(error) {              
            }
        },     
    // Interagisce con i giorni di chiusura settimanale dell'attività, ad ogni cambiamento 
    // di un campo check (da lun a dom) viene aggiornato il db firebase  
        chiusuraSettimanaleSalvata(id, index) {  
            fb.db.collection('chiusuraSettimanale').doc(id).update({
                    aperto: this.settimana[index].aperto
                    
            })
        },
    // Metodo per aggiornare firebase con le ferie salvate
        salvaFerie(id, index) {
            fb.db.collection('ferie').doc(id).update({
                dateIn: this.ferie[index].dateIn,
                dateOut: this.ferie[index].dateOut
            }).then(this.snackbar = true)
        },
        salvaOrarioGiorno(id, indice) {
            fb.db.collection('orario').doc(id).update({
                inizio1: this.orario[indice].inizio1,
                fine1: this.orario[indice].fine1,
                inizio2: this.orario[indice].inizio2,
                fine2: this.orario[indice].fine2,
                continuato: this.orario[indice].continuato
            }).then(this.snackbarFascia = true)
        },
        calendarioLashmaker(nomecognome) {
            // Divido nomecognome in 2 costanti rispettivamente nome e cognome
            const nome = nomecognome.split(" ")[0]
            const cognome = nomecognome.split(" ")[1]
            this.orarioLashmaker= []
            // Gestioni fascia oraria per singolo giorno
            fb.db.collection('orarioLashmaker').where('cognome','==', cognome).where('nome','==', nome)
                 .orderBy("indice")
                 .onSnapshot(res => {
                const changes = res.docChanges()
                changes.forEach(change => {
                        if (change.type === "added")  {
                        this.orarioLashmaker.push({
                            ...change.doc.data(),
                            id: change.doc.id
                        })
                    }
                })
            })            
        },
        salvaOrarioLashmaker(id, indice) {
            if (this.orarioLashmaker[indice].continuato) {
                this.orarioLashmaker[indice].inizio2 = "00:00"
                this.orarioLashmaker[indice].fine2 = "00:00"
            } else {
                this.orarioLashmaker[indice].continuato = false
            }
            fb.db.collection('orarioLashmaker').doc(id).update({
                            inizio1: this.orarioLashmaker[indice].inizio1,
                            fine1: this.orarioLashmaker[indice].fine1,
                            inizio2: this.orarioLashmaker[indice].inizio2,
                            fine2: this.orarioLashmaker[indice].fine2,
                            continuato: this.orarioLashmaker[indice].continuato
            }).then(this.snackbarLashmaker = true)
        },
        // metodo per le regole del text field inizio1
        inputRulesInizio1(indice) {
            if ( ( this.orarioLashmaker[indice].inizio1 >= this.orario[indice].inizio1  && 
                   this.orarioLashmaker[indice].inizio1 < this.orario[indice].fine1 ) ||
                 ( this.orarioLashmaker[indice].inizio1 == "00:00"  &&
                   this.orarioLashmaker[indice].fine1 == "00:00" )
               ) {                     
                 return true
            } else {
                 return "Orario non lavorativo"
            }
        },
        // metodo per le regole del text field fine1
        inputRulesFine1(indice) {
            if ( ( this.orarioLashmaker[indice].fine1 <= this.orario[indice].fine1 &&
                   this.orarioLashmaker[indice].fine1 > this.orario[indice].inizio1 ) ||
                 ( this.orarioLashmaker[indice].inizio1 == "00:00"  &&
                   this.orarioLashmaker[indice].fine1 == "00:00" )
               ) {     
                 return true
            } else {
                 return "Orario non lavorativo"
            }
        },
        // metodo per le regole del text field inizio2
        inputRulesInizio2(indice) {
            if ( ( this.orarioLashmaker[indice].inizio2 >= this.orario[indice].inizio2 && 
                   this.orarioLashmaker[indice].inizio2 < this.orario[indice].fine2 ) ||
                 ( this.orarioLashmaker[indice].inizio2 == "00:00"  &&
                   this.orarioLashmaker[indice].fine2 == "00:00" )                   
               ) {     
                 return true
            } else {
                 return "Orario non lavorativo"
            }
        },
        // metodo per le regole del text field fine2
        inputRulesFine2(indice) {
            if ( ( this.orarioLashmaker[indice].fine2 <= this.orario[indice].fine2 &&
                   this.orarioLashmaker[indice].fine2 > this.orario[indice].inizio2 ) ||
                 ( this.orarioLashmaker[indice].inizio2 == "00:00"  &&
                   this.orarioLashmaker[indice].fine2 == "00:00" )                   
               ) {     
                 return true
            } else {
                 return "Orario non lavorativo"
            }
        },                
        // abilitazione tasto SAVE solo se le regole sono rispettate
        abilitaSalva(indice) {
            if ( ( this.orarioLashmaker[indice].inizio1 >= this.orario[indice].inizio1  && 
                   this.orarioLashmaker[indice].inizio1 < this.orario[indice].fine1 &&
                   this.orarioLashmaker[indice].fine1 <= this.orario[indice].fine1 &&
                   this.orarioLashmaker[indice].fine1 > this.orario[indice].inizio1 &&
                   this.orarioLashmaker[indice].inizio2 >= this.orario[indice].inizio2 && 
                   this.orarioLashmaker[indice].inizio2 < this.orario[indice].fine2 &&
                   this.orarioLashmaker[indice].fine2 <= this.orario[indice].fine2 &&
                   this.orarioLashmaker[indice].fine2 > this.orario[indice].inizio2 ) || //Oppure
                 ( this.orarioLashmaker[indice].inizio1 >= this.orario[indice].inizio1  && 
                   this.orarioLashmaker[indice].inizio1 < this.orario[indice].fine1 &&
                   this.orarioLashmaker[indice].fine1 <= this.orario[indice].fine1 &&
                   this.orarioLashmaker[indice].fine1 > this.orario[indice].inizio1 &&
                   this.orarioLashmaker[indice].inizio2 == "00:00" &&
                   this.orarioLashmaker[indice].fine2 == "00:00" ) || //Oppure
                 ( this.orarioLashmaker[indice].inizio2 >= this.orario[indice].inizio2 && 
                   this.orarioLashmaker[indice].inizio2 < this.orario[indice].fine2 &&
                   this.orarioLashmaker[indice].fine2 <= this.orario[indice].fine2 &&
                   this.orarioLashmaker[indice].fine2 > this.orario[indice].inizio2 &&
                   this.orarioLashmaker[indice].inizio1 == "00:00" &&
                   this.orarioLashmaker[indice].fine1 == "00:00" ) || //Oppure 
                 ( this.orarioLashmaker[indice].inizio2 == "00:00" &&
                   this.orarioLashmaker[indice].fine2 == "00:00" &&
                   this.orarioLashmaker[indice].inizio1 == "00:00" &&
                   this.orarioLashmaker[indice].fine1 == "00:00" ) || //Oppure 
                 ( this.orario[indice].continuato == true &&
                   this.orarioLashmaker[indice].inizio1 >= this.orario[indice].inizio1 &&
                   this.orarioLashmaker[indice].inizio1 < this.orario[indice].fine1 &&               
                   this.orarioLashmaker[indice].fine1 <= this.orario[indice].fine1 &&
                   this.orarioLashmaker[indice].fine1 > this.orario[indice].inizio1 &&
                   this.orarioLashmaker[indice].inizio2 > this.orarioLashmaker[indice].fine1 &&
                   this.orarioLashmaker[indice].inizio2 < this.orario[indice].fine1 &&               
                   this.orarioLashmaker[indice].fine2 <= this.orario[indice].fine1 &&
                   this.orarioLashmaker[indice].fine2 > this.orario[indice].inizio1 )  || //Oppure 
                 ( this.orarioLashmaker[indice].continuato == true &&
                   this.orarioLashmaker[indice].inizio1 >= this.orario[indice].inizio1 &&
                   this.orarioLashmaker[indice].inizio1 < this.orario[indice].fine1 &&               
                   this.orarioLashmaker[indice].fine1 <= this.orario[indice].fine1 &&
                   this.orarioLashmaker[indice].fine1 > this.orario[indice].inizio1 )
                ) {
                    return false  //abilita salva
            } else {
                    return true   //disabilita salva
            }
        },
        salvaIntervallo() {
            fb.db.collection('intervalli').doc('intervallo').set({
                intervallo : this.intervallo
            }).then(this.snackbarIntervallo = true)
        }
    },
    beforeCreate() {

        // Gestioni giorni apertura/chiusura settimanale
        fb.db.collection('chiusuraSettimanale').onSnapshot(res => {
        const changes = res.docChanges()
        if (changes.length == 0) {
            // Creo Giorni della Settimana con flag a true
            this.sett.forEach(giorno => fb.db.collection('chiusuraSettimanale').add(giorno))   
            } else {
                // Leggo Giorni della Settimana con relativi valori flag
                fb.db.collection('chiusuraSettimanale').orderBy("indice").onSnapshot(res => {
                    const changes = res.docChanges()
                    changes.forEach(change => {
                        if (change.type === "added")  {
                        this.settimana.push({
                            ...change.doc.data(),
                            id: change.doc.id
                        })
                        }
                    })
                })        
            }
        }),

        // Gestioni giorni di ferie
        fb.db.collection('ferie').onSnapshot(res => {
        const changes = res.docChanges()
        if (changes.length == 0) {
            // Creo giorno inizio ferie e giorno fine ferie
            this.initFerie.forEach(ferie => fb.db.collection('ferie').add(ferie))
            } 
            else {
                // Leggo giorno inizio ferie e giorno fine ferie
                fb.db.collection('ferie').onSnapshot(res => {
                    const changes = res.docChanges()
                    changes.forEach(change => {
                        if (change.type === "added")  {
                        this.ferie.push({
                            ...change.doc.data(),
                            id: change.doc.id
                        })
                        }
                    })
                })        
            }
        }),
        
        // Gestioni fascia oraria per singolo giorno
        fb.db.collection('orario').onSnapshot(res => {
        const changes = res.docChanges()

        if (changes.length == 0) {
            // Creo fasce orarie inizializzandole a zero per ogni singolo giorno della settimana
            this.initOrario.forEach(orario => fb.db.collection('orario').add(orario))
            } 
            else {
                // Leggo fasce orarie per ogni singolo giorno
                 fb.db.collection('orario').orderBy("indice").onSnapshot(res => {
                    const changes = res.docChanges()
                    changes.forEach(change => {
                            if (change.type === "added")  {
                            this.orario.push({
                                ...change.doc.data(),
                                id: change.doc.id
                            })
                        }
                    })
                })
            }
        }),

        //carico nome e cognome delle Lashmaker selezionabili
        fb.db.collection('lashmaker').onSnapshot(res => {
        const changes = res.docChanges()
        changes.forEach(change => {
            if (change.type === "added")  {
            this.lashmaker.push({
                ...change.doc.data(),
                id: change.doc.id
            })
            }
        })
        })                
    }    
}
</script>

<style scope>
.v-input--checkbox .v-label.theme--light{font-size: 12px;}
</style>